import { render, staticRenderFns } from "./BusinessAlias.vue?vue&type=template&id=5f7a22ee&"
import script from "./BusinessAlias.vue?vue&type=script&lang=js&"
export * from "./BusinessAlias.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAlias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports